module.exports = __webpack_public_path__ + "static/media/notificationdisable.aced4015.svg";